require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/es7.symbol.observable.js
// module id = 320
// module chunks = 0